// Montserrat and Inter Display font families and variants
export const FONTS = {
    // Montserrat
    MONTSERRAT_REGULAR: 'Montserrat, sans-serif',
    MONTSERRAT_BOLD: 'Montserrat, sans-serif',
    MONTSERRAT_SEMIBOLD: 'Montserrat, sans-serif',
    MONTSERRAT_MEDIUM: 'Montserrat, sans-serif',
    MONTSERRAT_EXTRABOLD: 'Montserrat, sans-serif',
    MONTSERRAT_ITALIC: 'Montserrat, sans-serif',
    MONTSERRAT_BOLD_ITALIC: 'Montserrat, sans-serif',
    MONTSERRAT_SEMIBOLD_ITALIC: 'Montserrat, sans-serif',
    MONTSERRAT_MEDIUM_ITALIC: 'Montserrat, sans-serif',
    MONTSERRAT_EXTRABOLD_ITALIC: 'Montserrat, sans-serif',

    // Inter Display
    INTER_REGULAR: 'Inter, sans-serif',
    INTER_MEDIUM: 'Inter, sans-serif',
    INTER_SEMIBOLD: 'Inter, sans-serif',
    INTER_BOLD: 'Inter, sans-serif',
    INTER_EXTRABOLD: 'Inter, sans-serif',
    INTER_ITALIC: 'Inter, sans-serif',
    INTER_MEDIUM_ITALIC: 'Inter, sans-serif',
    INTER_SEMIBOLD_ITALIC: 'Inter, sans-serif',
    INTER_BOLD_ITALIC: 'Inter, sans-serif',
    INTER_EXTRABOLD_ITALIC: 'Inter, sans-serif',
};

// Usage example:
// font-family: FONTS.MONTSERRAT_REGULAR; font-weight: 400;
// font-family: FONTS.MONTSERRAT_MEDIUM; font-weight: 500;
// font-family: FONTS.MONTSERRAT_SEMIBOLD; font-weight: 600;
// font-family: FONTS.MONTSERRAT_BOLD; font-weight: 700;
// font-family: FONTS.MONTSERRAT_EXTRABOLD; font-weight: 800;
// font-family: FONTS.MONTSERRAT_ITALIC; font-style: italic; font-weight: 400;
// font-family: FONTS.MONTSERRAT_MEDIUM_ITALIC; font-style: italic; font-weight: 500;
// font-family: FONTS.MONTSERRAT_SEMIBOLD_ITALIC; font-style: italic; font-weight: 600;
// font-family: FONTS.MONTSERRAT_BOLD_ITALIC; font-style: italic; font-weight: 700;
// font-family: FONTS.MONTSERRAT_EXTRABOLD_ITALIC; font-style: italic; font-weight: 800;